export function normalizePhoneNumber(raw: string) {
  // Remove qualquer caractere que não seja número
  const digits = raw.replace(/\D/g, '');

  // Exemplo de lógica para formatar: se tiver 11 dígitos → celular com DDD, senão → fixo com DDD
  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  // Se não for 10 ou 11 dígitos, retorna como está
  return digits;
}
